import React, { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MdCall, MdWhatsapp, MdEmail, MdOpenInNew } from "react-icons/md";
import { IoMdArrowDropright, IoMdArrowForward } from 'react-icons/io';
import { AppContext } from "../../App";
import { FiArrowRight, FiMail, FiGlobe, FiCloud, FiSmartphone, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import banner1 from '../../assets/banner2.png';
import bg from '../../assets/bg.jpg';
import banner2 from "../../assets/banner3.png";
import banner4 from "../../assets/banner4.png";
import heroImg from "../../assets/heroImg.jpg";

import agricultureImg from '../../assets/agriculture.png';
import aquacultureImg from '../../assets/aquaculture.png';
import tourismImg from '../../assets/tourism.png';
import transportImg from '../../assets/transportation.png';

// website logos
import kwetuLogo from '../../assets/kwetuAfrica.png';
import nassa from '../../assets/nassa.png';
import ncclLogo from '../../assets/nccl.png';
import kabalenziLogo from '../../assets/kabalenzi.png';
import kjLogo from '../../assets/kjConsult.png';
import kitchenKingsLogo from '../../assets/kitchenKings.png';
import familyFarmersLogo from '../../assets/familyFarmers.png';
import tchiLogo from '../../assets/tachi.png';
import coraggioLogo from '../../assets/coraggio.png';
import ckmLogo from '../../assets/ckm.png';
import namburi from '../../assets/namburi.png';
import isiringiti from '../../assets/isiringiti.jpg';


import AOS from 'aos';
import 'aos/dist/aos.css';

export default function HomeBanner1() {
  
  const appContext = useContext(AppContext);

  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  // slider for hero image showcase
  const heroSlides = [
    { src: agricultureImg, badge: "Agriculture", label: "Modern Agriculture Portal" },
    { src: aquacultureImg, badge: "Aquaculture", label: "Innovative Fish Farming Site" },
    { src: tourismImg, badge: "Tourism", label: "Tourism & Adventure Hub" },
    { src: transportImg, badge: "Transportation", label: "Logistics & Transport Site" }
  ];
  const [heroIndex, setHeroIndex] = useState(0);
  const [showNav, setShowNav] = useState(false);

  const prevHero = () =>
    setHeroIndex((i) => (i === 0 ? heroSlides.length - 1 : i - 1));
  const nextHero = () =>
    setHeroIndex((i) => (i === heroSlides.length - 1 ? 0 : i + 1));

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex((prev) =>
        prev === heroSlides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [heroSlides.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 6000); // 6 seconds

    return () => clearInterval(interval);
  }, []);

  function view() {
    appContext.navTo({item:'view', subItem:'websites'});
  }

  const features = [
    "Custom portfolio website design",
    "Mobile-first & responsive layout",
    "Fast loading & SEO-ready",
    "Professional UI/UX",
    "Contact & WhatsApp integration",
    "Hosting & deployment support",
    "Post-launch support"
  ];

  const pricing = [
    { title: "Portfolio Website", price: "300,000 TZS", desc: "Clean personal & professional portfolio" },
  ];
  
  const websites = [
    {
      name: "Namburi Seeds Co.",
      url: "https://namburiseeds.co.tz",
      category: "Seed Supply",
      logo: namburi,
      desc: "Agricultural supplier providing high-quality seeds to farmers nationwide."
    },
    {
      name: "Kwetu Africa Adventures",
      url: "https://kwetuafricaadventures.com",
      category: "Tourism",
      logo: kwetuLogo,
      desc: "A vibrant travel site showcasing safari packages and adventure tours across Tanzania."
    },
    {
      name: "Nassa Consult",
      url: "https://nassaconsult.co.tz",
      category: "Consultancy",
      logo: nassa,
      desc: "Consultation firm specializing in business strategy, market research, and project management services." 
    },
    {
      name: "Nahdi Crusher Company Limited",
      url: "https://nccl.tz",
      category: "Transportation",
      logo: ncclLogo,
      desc: "Corporate portal for a limestone transportation and crushing business."
    },
    {
      name: "Kabalenzi Enterprises",
      url: "https://kabalenzienterprises.co.tz",
      category: "Mining",
      logo: kabalenziLogo,
      desc: "Professional website highlighting mining operations and services."
    },
    {
      name: "KJ Consultants",
      url: "https://kjconsultancy.co.tz",
      category: "Consultation",
      logo: kjLogo,
      desc: "Clean consultancy landing page for business advisory services."
    },
    {
      name: "Kitchen Kings",
      url: "https://kitchenkings.co.tz",
      category: "Carpentry",
      logo: kitchenKingsLogo,
      desc: "Portfolio site showcasing high-end custom kitchen builds."
    },
    {
      name: "The Family Farmers",
      url: "https://thefamilyfarmers.co.tz",
      category: "Agriculture",
      logo: familyFarmersLogo,
      desc: "A modern site promoting sustainable family farming products."
    },
    {
      name: "Tanzania Children Hope Innovations",
      url: "https://tchi.or.tz",
      category: "NGO",
      logo: tchiLogo,
      desc: "Nonprofit website sharing impact stories and donation info."
    },
    {
      name: "Isiringiti Fish Cages",
      url: "https://isiringitifishhub.co.tz",
      category: "Aquaculture",
      logo: isiringiti,
      desc: "Informative site about innovative fish cage technology."
    },
    {
      name: "Coraggio Security",
      url: "https://coraggiosecurity.co.tz",
      category: "Security",
      logo: coraggioLogo,
      desc: "Professional security firm website with service listings."
    },
    {
      name: "CKM Company",
      url: "https://ckmcompany.co.tz",
      category: "Electrical",
      logo: ckmLogo,
      desc: "Business site for electrical installations and consultancy."
    }
  ];


  const testimonials = [
    {
      company: "Zosho Company Limited",
      message:
        "Before switching to Werenium Technologies, we often experienced issues with our corporate emails not being delivered. Since moving to Werenium, our communication has been smooth, reliable, and stress-free. Their service is fast, dependable, and truly professional.",
      rating: 5
    },
    {
      company: "Caremed Gas Limited",
      message:
        "Werenium Technologies created for us a standard, professional, and highly descriptive website that perfectly reflects our business. The design is clear, attractive, and easy for our clients to understand. We are very happy with the quality and professionalism of their work.",
      rating: 5
    },
    {
      company: "Kobe konsult",
      message:
        "The website is very beautiful and was completed within the agreed time. I am truly impressed by the professionalism and dedication of the Werenium Technologies development team. Excellent work!",
      rating: 5
    },
    {
      company: "G8 Energy Limited",
      message:
        "Werenium Technologies really impressed us. The website looks amazing, clean, and very professional. It stands out and represents our brand perfectly.",
      rating: 5
    },
    {
      company: "Skill link",
      message:
        "The corporate website Werenium Technologies developed for us looks professional, clean, and very attractive. Their service is reliable and truly professional.",
      rating: 5
    }
  ];
    const SERVICES = [
        {
          key: "software/appdev",
          title: "Application Development",
          description: "Custom mobile and desktop apps that scale with your business.",
          image: banner1,
        },
        {
          key: "systemdev",
          title: "System Development",
          description: "Enterprise-grade systems to automate and optimize operations.",
          image: banner2,
        },
        {
          key: "tax-compliance",
          title: "Tax Compliance",
          description: "Efficient, TRA-compliant electronic filing solutions.",
          image: banner4,
          externalUrl: "https://werenium.com/tax-compliance",
        }
      ];

  return (
    <div className="webdev-page" style={{marginTop:"var(--topBarHeight"}}>

      <section
        className="webdev-hero d-flex align-items-center justify-content-center text-white"
        style={{
          minHeight: 'calc(100vh - 70px)', // adjust 80px to your TopBar height
          backgroundImage: `
            radial-gradient(circle at top, rgba(59,130,246,0.15), transparent 60%),
            linear-gradient(rgba(35, 35, 39, 0.85), rgba(58, 58, 61, 0.75)),
            url(${bg})
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-md-6 mt-3">
              <h1
                className="fw-bold mb-4"
                style={{
                  fontSize: 'clamp(2.8rem, 6vw, 4.5rem)',
                  lineHeight: '1.1'
                }}
              >
                Werenium Web Development
              </h1>

              <p
                className="mx-auto mb-5"
                style={{
                  maxWidth: '720px',
                  fontSize: '1.15rem',
                  color: 'rgba(255,255,255,0.85)'
                }}
              >
                We design and build modern portfolio websites that position professionals,
                startups, and brands with clarity, credibility, and conversion in mind.
              </p>

              <div className="d-flex justify-content-start">
                <a
                  href="https://wa.me/255758779913"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-secondary btn-lg px-5 py-3 d-inline-flex align-items-center gap-2"
                  style={{
                    fontSize: '1rem',
                    boxShadow: '0 20px 40px rgba(21, 22, 24, 0.35)'
                  }}
                >
                  Get Your Offer Now <IoMdArrowForward size={20} />
                </a>
              </div>
            </div>
            <div
              className="col-md-6 p-2 position-relative mt-3"
              onMouseEnter={() => setShowNav(true)}
              onMouseLeave={() => setShowNav(false)}
            >
              <div className="position-relative w-100" style={{ borderRadius: '0.7rem', overflow: 'hidden' }}>
                <img
                  src={heroSlides[heroIndex].src}
                  className='w-100'
                  style={{
                    display: 'block',
                    border: "5px solid white",
                    transition: 'opacity 0.5s ease',
                    borderRadius: '0.7rem'
                  }}
                />
                {/* bottom gradient */}
                <div className="position-absolute inset-0 bg-gradient-to-t from-black via-transparent" />

                {/* badge and label pill */}
                <div
                  className="position-absolute px-2 py-1 bg-primary bg-opacity-75 mShadow1 text-white rounded-pill text-sm"
                  style={{
                    backdropFilter: 'blur(3px)',
                    bottom: '0.75rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1,
                    fontSize: '1rem'
                  }}
                >
                  {heroSlides[heroIndex].badge}
                </div>
                <div
                  className="position-absolute bottom-3 start-3 px-3 py-1 bg-dark bg-opacity-80 text-white rounded-pill"
                  style={{ fontSize: '0.9rem', backdropFilter:'blur(4px)' }}
                >
                  {heroSlides[heroIndex].label}
                </div>

                {/* navigation arrows */}
                <button
                  className="position-absolute top-50 start-0 translate-middle-y btn btn-circle btn-dark"
                  style={{
                    padding: '0.5rem',
                    opacity: showNav ? 0.9 : 0.15,
                    transition: 'opacity 0.2s'
                  }}
                  onClick={prevHero}
                >
                  <FiChevronLeft className="text-white" size={20} />
                </button>
                <button
                  className="position-absolute top-50 end-0 translate-middle-y btn btn-circle btn-dark"
                  style={{
                    padding: '0.5rem',
                    opacity: showNav ? 0.9 : 0.15,
                    transition: 'opacity 0.2s'
                  }}
                  onClick={nextHero}
                >
                  <FiChevronRight className="text-white" size={20} />
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </section>


      <section
        className="py-5"
        style={{
          background: `
            radial-gradient(circle at top, rgba(59,130,246,0.08), transparent 60%),
            linear-gradient(180deg, #f8fafc, #ffffff)
          `
        }}
      >
        <div className="container text-center">

          {/* SECTION INTRO */}
          <div className="mb-5" data-aos="fade-up">
            <h2 className="font-bold text-primary mb-3">
              Portfolio Website Development Offer
            </h2>

            <p
              className="text-muted mx-auto"
              style={{ maxWidth: '760px', fontSize: '1.05rem' }}
            >
             A streamlined, cost-effective portfolio website for professionals and small businesses.
            </p>
          </div>

          {/* FEATURES GRID */}
          <div className="row justify-content-center">
            {[
              {
                img: banner1,
                icon: "📧",
                title: "Corporate Emails",
                desc: "Branded email accounts on your domain."
              },
              {
                img: banner2,
                icon: "🌐",
                title: "Domain Name",
                desc: "Custom website address included."
              },
              {
                img: banner4,
                icon: "☁️",
                title: "1 Year Hosting",
                desc: "Fast, secure hosting for 12 months."
              },
              {
                img: heroImg,
                icon: "📱",
                title: "Responsive Layout",
                desc: "Looks great on phones, tablets, desktops."
              }
            ].map((item, i) => (
              <div
                key={i}
                className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                data-aos="fade-right"
                data-aos-delay={i * 80}
              >
                <div
                  className="card h-100 border-0 rounded shadow-sm"
                  onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)'; }}
                  style={{
                    backgroundImage: `url(${item.img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: '1.5rem !important',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                >
                  <div
                    className="card-overlay d-flex flex-column justify-content-end"
                    style={{
                      background: 'rgba(0,0,0,0.75)',
                      backdropFilter: 'blur(4px)',
                      padding: '1.5rem',
                      height: '100%'
                    }}
                  >
                    <div
                      className="mb-3 d-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-40"
                      style={{
                        width: '56px',
                        height: '56px',
                        fontSize: '1.5rem',
                        lineHeight: '1',
                        margin: '0 auto'
                      }}
                    >
                      {item.icon}
                    </div>
                    <h5 className="text-white fw-bold mb-3" style={{fontSize:'1.1rem', textShadow:'0 1px 2px rgba(0,0,0,0.5)'}}>
                      {item.title}
                    </h5>
                    <p className="text-white small mb-1" style={{lineHeight:1.3}}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


     {/* PRICING */}
      <section
        className="py-5"
        style={{
          background: `
            radial-gradient(circle at top, rgba(59,130,246,0.08), transparent 60%),
            linear-gradient(180deg, #ffffff, #f8fafc)
          `
        }}
      >
        <div className="container text-center">

          {/* Section Header */}
          <div className="mb-5" data-aos="fade-up">
            <h2 className="font-bold text-primary mb-3">Pricing</h2>
            <p
              className="text-muted mx-auto"
              style={{ maxWidth: '640px', fontSize: '1.05rem' }}
            >
              Simple, transparent pricing designed to fit professionals, startups,
              and growing businesses.
            </p>
          </div>

          {/* Pricing Cards */}
          <div className="row justify-content-center">

            {pricing.map((p, i) => (
              <div
                key={i}
                className="col-md-6 col-lg-4 mb-4"
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <div
                  className="h-100 rounded-3 shadow-lg overflow-hidden d-flex flex-column"
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)'; }}
                  style={{
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                >
                  {/* top colored section */}
                  <div className="p-4 bg-secondary text-white text-center">
                    <p className='font-bold'>{p.desc}</p>
                  </div>

                  {/* bottom light section */}
                  <div className="flex-grow-1 p-4 bg-light text-center d-flex flex-column justify-content-between">
                    <h4 className="fw-bold mb-1" style={{ fontSize: '1.75rem' }}>
                      {p.price}
                    </h4>
                    <h5 className="fw-semibold mb-3">
                      {p.title}
                    </h5>
                    <button className="btn btn-primary mt-auto" >
                       <a
                        href="tel:+255758779913"
                        className="text-light"
                        style={{ textDecoration: 'none' }}
                      >
                        Get Started
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="py-5"
        style={{
          background: `
            radial-gradient(circle at top, rgba(59,130,246,0.15), transparent 60%),
            linear-gradient(180deg, #242425, #020617)
          `
        }}
      >
        <div className="container" data-aos="fade-up">

          <div
            className="mx-auto text-center p-5 rounded-4"
            style={{
              maxWidth: '820px',
              background: 'rgba(255,255,255,0.06)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.12)'
            }}
          >
            <h2 className="fw-bold mb-3 text-white">
              Ready to Build a Professional Online Presence?
            </h2>

            <p
              className="mb-5"
              style={{
                color: 'rgba(255,255,255,0.75)',
                fontSize: '1.05rem'
              }}
            >
              Let’s turn your ideas into a clean, modern portfolio website
              that represents your brand and works for your goals.
            </p>

            {/* CTA Buttons */}
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">

              {/* Primary */}
              <a
                href="https://wa.me/255758779913"
                target="_blank"
                rel="noreferrer"
                className="btn btn-success btn-lg rounded-pill px-5"
                style={{
                  boxShadow: '0 20px 40px rgba(59,130,246,0.45)'
                }}
              >
                <MdWhatsapp size={22} />
              </a>

              {/* Secondary */}
              <a
                href="mailto:info@werenium.com"
                className="btn btn-danger btn-lg rounded-pill px-5"
                style={{
                  borderColor: 'rgba(255,255,255,0.4)'
                }}
              >
                <MdEmail size={20} />
              </a>

              {/* Tertiary */}
              <a
                href="tel:+255758779913"
                className="btn btn-outline-info btn-lg rounded-pill px-5"
                style={{ textDecoration: 'none' }}
              >
                <MdCall size={18} />
              </a>

            </div>
          </div>

        </div>
      </section>


     {/* PORTFOLIO */}
      <section
        className="py-5"
      >

        <div className="container">

          {/* Section Header */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="font-bold text-primary mb-3">Websites We’ve Built</h2>
            <h4 className="font-semi-bold text-muted">100+ Websites</h4>
            <p
              className="text-muted mx-auto"
              style={{ maxWidth: '640px', fontSize: '1.05rem' }}
            >
              A selection of portfolio and business websites we’ve designed and
              developed for clients across different industries.
            </p>
          </div>

          {/* Portfolio List */}
          <div className="row g-4 justify-content-center">
            {websites.map((w, i) => (
              <div key={i} className="col-sm-6 col-md-4">
                <div
                  className="h-100 p-4 d-flex flex-column align-items-center text-center" 
                  style={{ cursor: 'pointer', transition: 'transform 0.2s ease, box-shadow 0.2s ease', background: 'rgb(182, 179, 164)' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.12)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.08)'; }}
                  onClick={() => window.open(w.url,'_blank','noreferrer')}
                  
                >
                  {w.logo && (
                    <img
                      src={w.logo}
                      alt={`${w.name} logo`}
                      className="mb-3"
                      style={{ width: '80px', height: '80px', objectFit: 'contain' }}
                    />
                  )}
                  <h5 className="fw-bold mb-1" style={{ fontSize: '1.1rem' }}>{w.name}</h5>
                  <span className="badge bg-primary mb-2">{w.category}</span>
                  <p className="small text-muted mb-3" style={{ lineHeight: 1.4 }}>
                    {w.desc}
                  </p>
                  <a
                    href={w.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-secondary btn-sm mt-auto px-4 mShadow1"
                    style={{ boxShadow: '0 3px 5px rgba(26, 28, 32, 0.25)' }}
                  >
                    Visit Website <MdOpenInNew size={16} />
                  </a>
                </div>
              </div>
            ))}

            <div className="text-center mt-5">
              <button onClick={view} className='btn btn-primary'>
                View More Websites <IoMdArrowDropright size={24} />
              </button>
            </div>
          </div>
        </div>

        
      </section>

      


      {/* TESTIMONIALS */}
      <section

        className="py-5"
        style={{
          background:
            "linear-gradient(180deg, #020617, #0f172a)"
        }}
      >
        <div className="container" data-aos="fade-up">

          <div className="text-center mb-5">
            <h2 className="fw-bold text-white mb-3">
              What Our Clients Say
            </h2>
            <p className="text-light opacity-75">
              Real feedback from professionals and businesses we’ve worked with
            </p>
          </div>

          <div
            className="mx-auto text-center p-5 rounded-4"
            style={{
              maxWidth: "780px",
              background: "rgba(255,255,255,0.06)",
              backdropFilter: "blur(14px)",
              border: "1px solid rgba(255,255,255,0.12)"
            }}
          >
            {testimonials.map((t, i) => (
              <div
                key={i}
                className={`transition-all ${
                  i === activeIndex ? "d-block" : "d-none"
                }`}
              >
                {/* Quote */}
                <p
                  className="mb-4"
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "1.1rem",
                    lineHeight: 1.7
                  }}
                >
                  “{t.message}”
                </p>

                {/* Rating */}
                <div className="mb-4">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <span key={i} className="text-warning fs-5">★</span>
                  ))}
                </div>

                {/* Client */}
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <div className="text-start">
                    <small className="text-light opacity-75">
                      {t.company}
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Indicators */}
          <div className="d-flex justify-content-center gap-2 mt-4">
            {testimonials.map((_, i) => (
              <span
                key={i}
                onClick={() => setActiveIndex(i)}
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  cursor: "pointer",
                  background:
                    i === activeIndex
                      ? "#3b82f6"
                      : "rgba(255,255,255,0.3)"
                }}
              />
            ))}
          </div>

        </div>
      </section>

      <div className="container mt-5 pb-5">
      <h3 className="mb-4 text-center main-section-title">Related Services</h3>
      <div className="row g-4">
        {SERVICES.map(service => (
          <div key={service.key} className="col-md-4">
            <div
              className="position-relative rounded-4 overflow-hidden h-100 shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => {
                  appContext.navTo({ item: "services", subItem: service.key });
              }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-100 h-100"
                style={{ objectFit: "cover", transition: "transform 0.3s ease" }}
              />
              <div
                className="position-absolute inset-0 bg-dark bg-opacity-40"
                style={{ transition: "background 0.3s ease" }}
              />
              <div
                className="position-absolute bottom-0 start-0 w-100 p-3 text-white"
                style={{ backdropFilter: "blur(6px)", backgrouond:"rgba(0,0,0,.35" }}
              >
                <h5 className="mb-1 font-semi-bold text-secondary bg-primary p-2 rounded d-flex align-items-center justify-content-between" style={{ fontSize: "1.1rem" }}>
                  
                  <span>{service.title}</span> &nbsp; <FiArrowRight size={20} className="rounded bg-light p-1"/>
                </h5>
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>

      
     {/* CTA */}
      <section
        className="py-5"
        style={{
          background: `
            radial-gradient(circle at top, rgba(59,130,246,0.15), transparent 60%),
            linear-gradient(180deg, #0f172a, #020617)
          `
        }}
      >
        <div className="container" data-aos="fade-up">

          <div
            className="mx-auto text-center p-5 rounded-4"
            style={{
              maxWidth: '820px',
              background: 'rgba(255,255,255,0.06)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.12)'
            }}
          >
            <h2 className="fw-bold mb-3 text-white">
              Ready to Build a Professional Online Presence?
            </h2>

            <p
              className="mb-5"
              style={{
                color: 'rgba(255,255,255,0.75)',
                fontSize: '1.05rem'
              }}
            >
              Let’s turn your ideas into a clean, modern portfolio website
              that represents your brand and works for your goals.
            </p>

            {/* CTA Buttons */}
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">

              {/* Primary */}
              <a
                href="https://wa.me/255758779913"
                target="_blank"
                rel="noreferrer"
                className="btn btn-success btn-lg rounded-pill px-5"
                style={{
                  boxShadow: '0 20px 40px rgba(59,130,246,0.45)'
                }}
              >
                <MdWhatsapp size={22} />
              </a>

              {/* Secondary */}
              <a
                href="mailto:info@werenium.com"
                className="btn btn-danger btn-lg rounded-pill px-5"
                style={{
                  borderColor: 'rgba(255,255,255,0.4)'
                }}
              >
                <MdEmail size={20} />
              </a>

              {/* Tertiary */}
              <a
                href="tel:+255758779913"
                className="btn btn-outline-info btn-lg rounded-pill px-5"
                style={{ textDecoration: 'none' }}
              >
                <MdCall size={18} />
              </a>

            </div>
          </div>
        </div>
      </section>

  
    </div>
  );
}
